var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsLetterCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 40,
    height: 40,
    fill: "url(#paint0_linear_240_5213)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 14.666H17.3334C15.8607 14.666 14.6667 15.8599 14.6667 17.3327V27.9993C14.6667 29.4721 15.8607 30.666 17.3334 30.666H28.0001C29.4728 30.666 30.6667 29.4721 30.6667 27.9993V17.3327C30.6667 15.8599 29.4728 14.666 28.0001 14.666Z",
    stroke: "#CD63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 14.6673V12.0007C25.3333 11.2934 25.0523 10.6151 24.5522 10.115C24.0521 9.61494 23.3738 9.33398 22.6666 9.33398H11.9999C11.2927 9.33398 10.6144 9.61494 10.1143 10.115C9.6142 10.6151 9.33325 11.2934 9.33325 12.0007V22.6673C9.33325 23.3746 9.6142 24.0528 10.1143 24.5529C10.6144 25.053 11.2927 25.334 11.9999 25.334H14.6666",
    stroke: "#CD63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_5213",
    x1: -658,
    y1: 1357.6,
    x2: 2220.4,
    y2: 1357.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8100BE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsLetterCopy);
export default __webpack_public_path__ + "static/media/NewsLetterCopy.c5232fc8.svg";
export { ForwardRef as ReactComponent };